import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError, } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigModel } from './config.model';

export function ConfigurationServiceInitializerFactory(configurationService: ConfigService): Function {
  return () => configurationService.CargarConfguracion();
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  protected configPathFile: string = 'assets/data/8f2a1e93c7b4.json';
  protected configSubject: BehaviorSubject<ConfigModel> = new BehaviorSubject<ConfigModel>({});
  public config$: Observable<ConfigModel> = this.configSubject.asObservable();

  constructor(
    private http: HttpClient
  ) { }

  CargarConfguracion() {
    this.http.get<ConfigModel>(this.configPathFile)
      .pipe(catchError(error => {
        this.configSubject.next({});
        return throwError('No se encontró el archivo de configuración.');
      }))
      .subscribe(response => {
        this.configSubject.next(response as ConfigModel);
      });
  }
}
